/* eslint-disable */

/** unique or primary key constraints on table "argo.connection_config" */
export enum ArgoConnectionConfigConstraint {
  /** unique or primary key constraint on columns "connection_config_id" */
  ArgoConnectionConfigPkey = 'argo_connection_config_pkey',
  /** unique or primary key constraint on columns "connection_id" */
  ArgoConnectionConfigUniqueActiveVersion = 'argo_connection_config_unique_active_version',
  /** unique or primary key constraint on columns "version_number", "connection_id" */
  ArgoConnectionConfigUniqueVersionNumber = 'argo_connection_config_unique_version_number'
}

/** select columns of table "argo.connection_config" */
export enum ArgoConnectionConfigSelectColumn {
  /** column name */
  ApprovedById = 'approved_by_id',
  /** column name */
  Config = 'config',
  /** column name */
  ConnectionId = 'connection_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  VersionNumber = 'version_number'
}

/** update columns of table "argo.connection_config" */
export enum ArgoConnectionConfigUpdateColumn {
  /** column name */
  ApprovedById = 'approved_by_id',
  /** column name */
  Config = 'config',
  /** column name */
  ConnectionId = 'connection_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  VersionNumber = 'version_number'
}

